import React from 'react'
import styled from 'styled-components';
import parse from 'html-react-parser';


function IconOverlayCard({service}) {

  const OverlayStyle = styled.section `
  img:hover {
  transition: opacity 400ms;
  opacity: 0;
  }
  `
  
  return (
    <OverlayStyle>
    <div className='flex flex-col text-center items-center justify-center py-4 '>
      <div className="front">
        <div className="relative shadow-lg border border-gray-200 rounded-full h-60 w-60">
          <div className="absolute z-0 h-60 w-60 rounded-full flex items-center align-middle m-auto text-sm font-medium text-center">
            <span className="flex-grow text-base">{ parse(service.description) }</span>
          </div>
          <img src={service.icon} alt="teeth" className= 'z-1 absolute h-60 w-60' />
        </div>
        <h1 className="mt-4 font-bold text-lg md:text-xl h-12">{service.title}</h1>
      </div>
    </div>
  </OverlayStyle>
  )
}

export default IconOverlayCard;